var _defs, _text, _g, _g2, _g3, _g4, _g5, _g6, _g7, _tspan;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSemibold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 72,
    viewBox: "0 0 122 72",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath822"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 157h238v-157h-238z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3,0,0,-1.3,-102,144)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.39 0 0 .39 78.6 48.9)",
    clipPath: "url(#clipPath822)"
  }, _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1,0,0,-1,0,22)",
    fill: "#ffff00",
    fontFamily: "Caveat",
    fontSize: "72px"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 28.08 60.48 84.311996 107.712 140.112 163.944 190.584",
    y: 0,
    fontFamily: "Caveat",
    fontWeight: 600
  }, "Inventum"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(116,157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c28 0 50-22 50-50s-22-50-50-50-50 22-50 50 22 50 50 50",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-5.4 11-17 15-23 15-7 0-18-3.8-24-15-5.4-11-1.1-21 4.2-28 5.3-6.9 5.9-9.9 6.2-12 0.33-1.7-0.73-4.3 1.3-6.1 2-1.8 12-2.1 12-2.1s9.7 0.27 12 2.1c2 1.8 0.95 4.4 1.3 6.1 0.33 1.7 0.88 4.7 6.2 12s9.7 17 4.3 28",
    fill: "#ff0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(124,98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-3.1l0.01 0.95c0 2.8 1.3 5 3 5h0.17c1.6-0.048 2.9-1.4 2.9-3 0-1.7-1.3-3-3-3m-21 3c0 1.6 1.3 2.9 2.9 3h0.17c1.6 0 3-2.3 3-5l0.01-0.95h-3.1c-1.7 0-3 1.3-3 3m22 4.9c-0.29 0.053-0.58 0.09-0.88 0.09l-0.91-0.094c-2.3-0.44-4-2.5-4-4.9v-3h-7.9v3c0 2.5-1.7 4.5-4 4.9l-0.92 0.094c-0.3 0-0.6-0.037-0.89-0.09-2.4-0.39-4.2-2.4-4.2-4.9 0-2.8 2.2-5 5-5h3v-30h2v30h8v-30h2v30h3c2.8 0 5 2.2 5 5 0 2.5-1.8 4.5-4.2 4.9",
    fill: "#ddb857"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(87,134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.73 0.73-1.9 0.73-2.6 0-0.73-0.73-0.73-1.9 0-2.6l5.3-5.3c0.73-0.73 1.9-0.73 2.6 0 0.73 0.73 0.73 1.9 0 2.6zm60 0c-0.73 0.73-1.9 0.73-2.6 0l-5.3-5.3c-0.73-0.73-0.73-1.9 0-2.6 0.73-0.73 1.9-0.73 2.6 0l5.3 5.3c0.73 0.73 0.73 1.9 0 2.6m-47 9.3c-0.42 0.99-1.6 1.5-2.6 1-1-0.41-1.5-1.5-1.1-2.5l3-7.1c0.42-0.99 1.6-1.5 2.6-1 1 0.41 1.5 1.5 1.1 2.5zm33 1c-1 0.41-2.2-0.062-2.6-1l-3-7.1c-0.42-0.99 0.061-2.1 1.1-2.5 1-0.41 2.2 0.061 2.6 1l3 7.1c0.42 0.99-0.062 2.1-1.1 2.5m-18 4.1c-1.1 0-2-0.9-2-2v-8c0-1.1 0.9-2 2-2s2 0.9 2 2v8c0 1.1-0.9 2-2 2",
    fill: "#3182ce"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(107,68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2 1.8-0.96 4.4-1.3 6.1-0.33 1.7-0.9 4.7-6.2 12-5.3 6.9-9.7 17-4.2 28 5.1 10 15 14 22 15-0.52 0.037-1 0.061-1.5 0.061-7 0-18-3.8-24-15-5.4-11-1.1-21 4.2-28 5.3-6.9 5.9-9.9 6.2-12 0.33-1.7-0.73-4.3 1.3-6.1 2-1.8 12-2.1 12-2.1s0.59 0.016 1.5 0.067c-2.8 0.16-8.8 0.65-10 2",
    fill: "#d7b354"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(125,98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-3.1l0.01 0.95c0 2.8 1.3 5 3 5h0.17c1.6-0.048 2.9-1.4 2.9-3 0-1.7-1.3-3-3-3m-21 3c0 1.6 1.3 2.9 2.9 3h0.17c1.6 0 3-2.3 3-5l0.01-0.95h-3.1c-1.7 0-3 1.3-3 3m22 4.9c-0.29 0.053-0.58 0.09-0.88 0.09l-0.91-0.094c-2.3-0.44-4-2.5-4-4.9v-3h-7.9v3c0 2.5-1.7 4.5-4 4.9l-0.92 0.094c-0.3 0-0.6-0.037-0.89-0.09-2.4-0.39-4.2-2.4-4.2-4.9 0-2.8 2.2-5 5-5h3v-30h2v30h8v-30h2v30h3c2.8 0 5 2.2 5 5 0 2.5-1.8 4.5-4.2 4.9",
    fill: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(128,69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2-1.8-12-2.1-12-2.1s-9.8 0.27-12 2.1c-0.64 0.58-0.97 1.2-1.1 1.9h-0.084v-12c4.1-1.1 8.5-1.7 13-1.7s8.9 0.6 13 1.7v12h-0.093c-0.16-0.69-0.49-1.3-1.1-1.9",
    fill: "#efefef"
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "scale(1,-1)",
    x: 55.840454,
    y: -121.76633,
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: "78.9px",
    strokeWidth: 1.97,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 55.840454,
    y: -121.76633,
    strokeWidth: 1.97
  }, "\""))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSemibold);
export default __webpack_public_path__ + "static/media/logo-semibold.adfea922df4fb4e15088906fc2bd7047.svg";
export { ForwardRef as ReactComponent };